/**
 * UTM Parameter Tracker
 * Captures UTM parameters from URL and stores them in cookies
 */
(function() {
    'use strict';

    // Parameters to track
    const PARAMETERS_TO_TRACK = [
        'gclid',
        'utm_id', 
        'utm_source',
        'utm_medium',
        'utm_campaign',
        'utm_term',
        'utm_content'
    ];

    // Cookie configuration
    const COOKIE_CONFIG = {
        expires: 0.125,
        path: '/',
        sameSite: 'Lax',
        httpOnly: false
    };

    /**
     * Get URL parameter value by name
     * @param {string} name - Parameter name
     * @returns {string|null} Parameter value or null if not found
     */
    function getUrlParameter(name) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(name);
    }

    /**
     * Set cookie with specified name, value and options
     * @param {string} name - Cookie name
     * @param {string} value - Cookie value
     * @param {Object} options - Cookie options
     */
    function setCookie(name, value, options = {}) {
        const config = { ...COOKIE_CONFIG, ...options };
        let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
        
        if (config.expires) {
            const date = new Date();
            date.setTime(date.getTime() + (config.expires * 24 * 60 * 60 * 1000));
            cookieString += `; expires=${date.toUTCString()}`;
        }
        
        if (config.path) {
            cookieString += `; path=${config.path}`;
        }
        
        if (config.domain) {
            cookieString += `; domain=${config.domain}`;
        }
        
        if (config.sameSite) {
            cookieString += `; SameSite=${config.sameSite}`;
        }
        
        if (config.secure) {
            cookieString += `; Secure`;
        }

        document.cookie = cookieString;
    }

    /**
     * Get cookie value by name
     * @param {string} name - Cookie name
     * @returns {string|null} Cookie value or null if not found
     */
    function getCookie(name) {
        const nameEQ = encodeURIComponent(name) + "=";
        const cookies = document.cookie.split(';');
        
        for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i];
            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1, cookie.length);
            }
            if (cookie.indexOf(nameEQ) === 0) {
                return decodeURIComponent(cookie.substring(nameEQ.length, cookie.length));
            }
        }
        return null;
    }

    /**
     * Capture and store UTM parameters and gclid
     */
    function captureUtmParameters() {
        const capturedParams = {};
        let hasNewParams = false;

        // Check each parameter
        PARAMETERS_TO_TRACK.forEach(function(param) {
            const value = getUrlParameter(param);
            const existingValue = getCookie(param);
            
            if (value && value !== existingValue) {
                capturedParams[param] = value;
                setCookie(param, value);
                hasNewParams = true;
            }
        });

        // Store all parameters together as JSON for easy retrieval
        if (hasNewParams) {
            const allParams = {};
            PARAMETERS_TO_TRACK.forEach(function(param) {
                const value = getCookie(param);
                if (value) {
                    allParams[param] = value;
                }
            });
            
            setCookie('utm_data', JSON.stringify(allParams));
            
            // Dispatch custom event for other scripts to listen to
            const event = new CustomEvent('utmParametersCaptured', {
                detail: capturedParams
            });
            document.dispatchEvent(event);
        }
    }

    /**
     * Get all stored UTM parameters
     * @returns {Object} Object containing all stored UTM parameters
     */
    function getStoredUtmParameters() {
        const allParams = {};
        PARAMETERS_TO_TRACK.forEach(function(param) {
            const value = getCookie(param);
            if (value) {
                allParams[param] = value;
            }
        });
        return allParams;
    }

    /**
     * Clear all UTM cookies
     */
    function clearUtmParameters() {
        PARAMETERS_TO_TRACK.forEach(function(param) {
            setCookie(param, '', { expires: -1 });
        });
        setCookie('utm_data', '', { expires: -1 });
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', captureUtmParameters);
    } else {
        captureUtmParameters();
    }

    // Make functions available globally if needed
    window.UtmTracker = {
        getStoredParameters: getStoredUtmParameters,
        clearParameters: clearUtmParameters,
        captureParameters: captureUtmParameters
    };

})(); 